import Vue from 'vue';
import axios from 'axios';
import '../../../../filters';
import moment from 'moment';

const webMethodDef = {
  None:   { name: 'None',   type: 0 },
  Insert: { name: 'Insert', type: 1 },
  Update: { name: 'Update', type: 2 },
  Delete: { name: 'Delete', type: 3 }
};

export default {
  name: 'CustomReadings',
  components: {
    CustomReadingComp: require('../customReading/customReading.vue').default,
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      readings: [],
      editingReading: {},
      options: { pageSize: 5, total: 0, page: 1 },
      message: '',
      showReading: false,
      totalRow: 0
    }
  },
  created() {
    this.appId = this.dataObj;
    this.getReadings();
  },
  methods: {
    pageChange(pInfo) {
      //var parameters = { Value: this.appId, PageSize: pInfo.pageSize, Page: pInfo.pageNumber, FilterText: this.search };
      this.getReadings();
    },
    getReadings() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0
      };

      axios.post('/CustomMeterReadingActivity/GetCustomMeterReadingItems', parameter)
        .then(response => {
          if (response.data.data.status == 0) {
            response.data.items.forEach(item => item.readingDate = moment(item.readingDate));
            this.readings = response.data.items;
            this.options.total = response.data.total;
            this.totalRow = response.data.total;
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    add() {
      var now = moment();
      this.editingReading = {
        method: webMethodDef.Insert.type,
        applicationId: this.appId,
        orderId: 0,
        readingDate: new Date(),
        meterRef: '',
        reference: '',
        prevReading: 0,
        curReading: 0,
        consumption: 0,
        chargeableHours: 0,
        comments: '',
        readonly: false
      };
      this.$root.$emit('custom_meter_reading_updated');
      this.showReading = true;
    },
    edit(reading) {
      this.editingReading = reading;
	  this.editingReading.method = webMethodDef.Update.type;
      this.editingReading.readonly = false;
      this.$root.$emit('custom_meter_reading_updated');
      this.showReading = true;
    },
    saveReading() {
      this.editingReading.readingDate = moment(this.editingReading.readingDate).format();
      this.editingReading.consumption = this.editingReading.consumption === NaN ? 0 : this.editingReading.consumption;
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/CustomMeterReadingActivity/DoCustomMeterReadingItem', this.editingReading)
        .then(response => {
          if (response.data.data.status == 0) {
            if (this.editingReading.method == webMethodDef.Insert.type) {
              this.editingReading.orderId = response.data.id;
              this.readings.push(this.editingReading);
              this.options.total = this.readings.length;
            }
            this.$alertMsg(this.$t('messages.ReadingSavedSuccess'), 2);
            loader.hide();
          }
          else
            this.$alertMsg(response.data.data.text);

          this.showReading = false;
        })
        .catch((e) => { loader.hide(); this.$alertMsg(e.message); })
    },
    remove(reading) {
	  reading.method = webMethodDef.Delete.type;
      axios.post('/CustomMeterReadingActivity/DoCustomMeterReadingItem', reading)
        .then(response => {
          if (response.data.data.status == 0) {
            this.$alertMsg(this.$t('messages.ReadingDeletedSuccess'), 2);
            this.getReadings();
          }
        })
        .catch((e) => { this.$alertMsg(e.message); })
    },
    sendEmail(reading) {
      var emailModel = { ApplicationId: reading.applicationId, OrderId: reading.orderId, Email: '', Subject: '', Message: '' };
      axios.post('/CustomMeterReadingActivity/CreateCustomMeterReadingEmail', emailModel)
        .then(response => {

          if (response.data.data.status == 0) {
            var emailResponse = response.data.item;
            axios.post('/CustomMeterReadingActivity/SendEmail', emailResponse)
              .then(response => {
                if (response.data.data.status == 0) {
                  this.$alertMsg(this.$t('messages.EmailSentSuccess'), 2);
                }
                else {
                  this.$alertMsg(response.data.data.text);
                }
              })
              .catch(e => { this.$router.push('/login'); return false; })
          }
          else {
            this.$alertMsg(response.data.data.text);
          }

        })
        .catch((e) => { this.$alertMsg(e.message); })
    },
    sendSms(reading) {
      var smsModel = { ApplicationId: reading.applicationId, OrderId: reading.orderId, Address: '', Message: '' };
      axios.post('/CustomMeterReadingActivity/CreateCustomMeterReadingSms', smsModel)
        .then(response => {

          if (response.data.data.status == 0) {
            var smsResponse = response.data.item;
            axios.post('/CustomMeterReadingActivity/SendSms', smsResponse)
              .then(response => {
                if (response.data.data.status == 0) {
                  this.$alertMsg(this.$t('messages.SmsSentSuccess'), 2);
                }
                else {
                  this.$alertMsg(response.data.data.text);
                }
              })
              .catch(e => { this.$router.push('/login'); return false; })
          }
          else {
            this.$alertMsg(response.data.data.text);
          }

        })
        .catch((e) => { this.$alertMsg(e.message); })
    },
    closeDialog() {
      this.editingMessage = '';
      this.getReadings();
      this.showReading = false;
    },
    onPagination(args) {
      this.options.page = args.page;
      this.options.pageSize = args.size;
      this.getReadings();
    },
  },
  
}

